module.exports = __webpack_public_path__ + "img/outterEngraving@2x.ea1c139.webp";